import { render, staticRenderFns } from "./ControleMoverMarcacao.vue?vue&type=template&id=0f43f3b3&"
import script from "./ControleMoverMarcacao.vue?vue&type=script&lang=js&"
export * from "./ControleMoverMarcacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports